import { SystemActions, } from './types';
import { API } from '../../../vendor/api';
import { getAngularService } from '../../../modules/core';
import { getUserId, selectInstitution, } from '../../../store/features/system/selectors';
export const setUser = (user) => (dispatch) => {
    const payload = {
        id: user.id,
        type: user.type,
        locale: user.locale,
        title: user.title,
        firstName: user.firstName,
        lastName: user.lastName,
        betaAccesses: user.betaAccesses,
        institutionsMemberships: user.institutionsMemberships,
        subscriptionType: user.subscriptionType,
        displayName: user.displayName,
        userProfilePictureUrl: user.userProfilePictureUrl,
        lowQualityPhoto: user.lowQualityPhoto,
        preferredCurrency: user.preferredCurrency,
        stripeConnect: user.stripeConnect,
        email: user.email,
        roomName: user.roomName,
        password: user.password,
        profilePictureProvider: user.profilePictureProvider,
        useProfilePicture: user.useProfilePicture,
        noBaa: user.noBaa,
        designation: user.designation,
        speciality: user.speciality,
        NPI: user.NPI,
        identities: user.identities,
        isTrial: user.isTrial,
        trialEndDate: user.trialEndDate,
        dayPassEndDate: user.dayPassEndDate,
        browserNotifications: user.browserNotifications,
        emailNotifications: user.emailNotifications,
        smsNotifications: user.smsNotifications,
        soundNotification: user.soundNotification,
        soundMessage: user.soundMessage,
        emailNotificationsAddress: user.emailNotificationsAddress,
        smsNotificationsPhone: user.smsNotificationsPhone,
        notificationRoomType: user.notificationRoomType,
        institutionMember: user.institutionMember,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        currency: user.currency || 'USD',
        activePurchase: user.activePurchase,
        preferredInviteCountry: user.preferredInviteCountry,
        smsVerified: user.smsVerified,
        preferredLocale: user.preferredLocale,
        globalFeatures: user.globalFeatures,
        customerId: user.customerId,
    };
    dispatch({
        type: SystemActions.SET_USER,
        payload,
    });
};
export const updateUser = (user) => (dispatch) => {
    dispatch({
        type: SystemActions.UPDATE_USER,
        payload: user,
    });
};
export const setInstitution = (institution) => (dispatch) => {
    dispatch({
        type: SystemActions.SET_INSTITUTION,
        payload: institution,
    });
};
export const updateInstitution = (institution) => (dispatch) => {
    dispatch({
        type: SystemActions.UPDATE_INSTITUTION,
        payload: institution,
    });
};
export const updateInstitutionAccess = (institutionAccess) => (dispatch) => {
    dispatch({
        type: SystemActions.UPDATE_INSTITUTION_ACCESS,
        payload: institutionAccess,
    });
};
export const setRoom = (room) => (dispatch) => {
    const $rootScope = getAngularService('$rootScope');
    $rootScope.$emit('room:change', room.id);
    dispatch({
        type: SystemActions.SET_ROOM,
        payload: room,
    });
};
export const updateRoom = (room) => async (dispatch) => {
    const updatedRoom = await API.room.update({ id: room.id, props: room });
    dispatch({
        type: SystemActions.UPDATE_ROOM,
        payload: updatedRoom,
    });
};
export const updateCheckInPhotosFlag = (isEnabled) => async (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);
    const institution = selectInstitution(state);
    await API.userManageableFeatures.setFeatureValue({
        featureKey: 'CHECK_IN_PHOTO_CAPTURE',
        isEnabled,
        userId,
        institutionId: institution ? institution.id : null,
    });
    dispatch({
        type: SystemActions.UPDATE_USER_MANAGEABLE_FEATURES,
        payload: {
            CHECK_IN_PHOTO_CAPTURE: isEnabled,
        },
    });
};
export const setRooms = (rooms) => (dispatch) => {
    dispatch({
        type: SystemActions.SET_ROOMS,
        payload: rooms,
    });
};
export const setLocationDetails = (locationDetails) => (dispatch) => {
    dispatch({
        type: SystemActions.SET_LOCATION_DETAILS,
        payload: locationDetails,
    });
};
export const setPurchases = (purchases) => (dispatch) => {
    dispatch({
        type: SystemActions.SET_PURCHASES,
        payload: purchases,
    });
};
export const updatePurchases = (purchases) => (dispatch) => {
    dispatch({
        type: SystemActions.UPDATE_PURCHASES,
        payload: purchases,
    });
};
export const setPlans = (plans) => (dispatch) => {
    dispatch({
        type: SystemActions.SET_PLANS,
        payload: plans,
    });
};
export const setStates = (states) => (dispatch) => {
    dispatch({
        type: SystemActions.SET_STATES,
        payload: states,
    });
};
export const setLanguages = (languages) => (dispatch) => {
    dispatch({
        type: SystemActions.SET_LANGUAGES,
        payload: languages,
    });
};
export const setPersonalData = (personalData) => (dispatch) => {
    dispatch({
        type: SystemActions.SET_PERSONAL_DATA,
        payload: personalData,
    });
};
export const setLocationsLicensed = (locationsLicensed) => (dispatch) => {
    dispatch({
        type: SystemActions.SET_LOCATIONS_LICENSED,
        payload: locationsLicensed,
    });
};
export const setUserManageableFeatures = (userManageableFeatures) => (dispatch) => {
    dispatch({
        type: SystemActions.UPDATE_USER_MANAGEABLE_FEATURES,
        payload: userManageableFeatures,
    });
};
export const updateUserAction = (id, props, onAfterUserSave) => async (dispatch) => {
    try {
        const user = await API.user.updateUser({ id, payload: props });
        dispatch(updateUser(props));
        if (typeof onAfterUserSave === 'function') {
            onAfterUserSave(user);
        }
        return user;
    }
    catch (err) {
        console.error(err);
    }
    return null;
};
export const saveAfterLoginPath = () => (dispatch) => {
    dispatch({
        type: SystemActions.SAVE_AFTER_LOGIN_PATH,
    });
};
export const resetAfterLoginPath = () => (dispatch) => {
    dispatch({
        type: SystemActions.RESET_AFTER_LOGIN_PATH,
    });
};
